import Big from "big.js";
import { MAX_DECIMAL } from "../interface/orderOfProvision"
import { useTaxesPaid } from "./context/TaxesPaidContext";
// interface OrderOfProvisionItemsProps {
//   total: Big,
//   netAmountNotTaxed: Big,
//   netAmount: Big
//   otherTaxes: Big
// }
// { /*total, netAmountNotTaxed, netAmount, otherTaxes*/ }: Readonly<OrderOfProvisionItemsProps>

export default function OrderOfProvisionTotals() {
  const { totalToPay, totalWithoutTaxes, totalTaxes, exemptTax, vatNotTaxed } = useTaxesPaid();
  return (
    <div className="flex justify-content-between align-items-center shadow-4 p-3 border-1 flex-column md:flex-row my-3">
      <h3 className="title font-bold flex gap-3">Total <p className="font-semibold title">$ {totalToPay?.toFixed(MAX_DECIMAL)}</p></h3>
      <h3 className="font-normal flex gap-3">Neto gravado <p className="font-semibold text-black">$ {totalWithoutTaxes?.toFixed(MAX_DECIMAL)}</p></h3>
      <h3 className="font-normal flex gap-3">No gravado <p className="font-semibold text-black">$ {(vatNotTaxed ?? Big(0))?.toFixed(MAX_DECIMAL)}</p></h3>
      <h3 className="font-normal flex gap-3">IVA exento <p className="font-semibold text-black">$ {exemptTax?.toFixed(MAX_DECIMAL)}</p></h3>
      <h3 className="font-normal flex gap-3">Otros Impuestos <p className="font-semibold text-black">$ {totalTaxes?.toFixed(MAX_DECIMAL)}</p></h3>
    </div>)
}